import { Injectable } from '@angular/core';
import { ProfileService } from '../../services/profile/profile.service';
import { UserService } from '../../services/user/user.service';
import { Log } from '../../shared/log';
import * as _ from 'underscore';
const log = Log.getLogger('TemplateDrivenWidgetComponent');


@Injectable()

export class PreFillService {

  constructor(private profileService: ProfileService,
              private userService: UserService) {
  }

  preFill (pages, widgetValues) {
    this.isPreFillEnabled()
      .then((isPreFillEnabled) => {
        if (isPreFillEnabled) {
          this.asyncFillInPhoneNumber(pages, widgetValues);
          this.asyncFillInEmail(pages, widgetValues);
          this.asyncFillInProfileData(pages, widgetValues);
        }
      }).catch((error) => {
      log.error(error);
    });
  }

  fillInProfileData (pages, widgetValues, profile) {
    _.each(pages, (page) => {
      if (page['page_type'] === 'form_page') {
        _.each(page['form'], (form) => {
          if (form['control_name'] === 'first_name') {
            if (profile.firstname) {
              widgetValues.set('first_name', profile.firstname);
            }
          } else if (form['control_name'] === 'last_name') {
            if (profile.lastname) {
              widgetValues.set('last_name', profile.lastname);
            }
          } else if (form['control_name'] === 'name') {
            if (profile.firstname && profile.lastname) {
              widgetValues.set('name', profile.firstname + ' ' +  profile.lastname);
            }
          }
        });
      } else if (page['page_type'] === 'address_page') {
        widgetValues.set('suburb', profile.contactExtras.locality);
        widgetValues.set('postcode', profile.contactExtras.postcode);
      }
    });
  }

  fillInPhoneNumber(pages, widgetValues, phoneNumber) {
    _.each(pages, (page) => {
      if (page['page_type'] === 'form_page') {
        _.each(page['form'], (form) => {
          if (form['control_name'] === 'phone') {
            widgetValues.set('phone', phoneNumber);
          }
        });
      }
    });
  }

  fillInEmail(pages, widgetValues, email) {
    _.each(pages, (page) => {
      if (page['page_type'] === 'form_page') {
        _.each(page['form'], (form) => {
          if (form['control_name'] === 'email') {
            widgetValues.set('email', email);
          }
        });
      }
    });
  }

  asyncFillInPhoneNumber(pages, widgetValues) {
    this.profileService.getPreferredPhoneNumber()
      .then(phoneNumberObj => {
        if (phoneNumberObj) {
          this.fillInPhoneNumber(pages, widgetValues, phoneNumberObj.phone_number);
        }
      })
      .catch((error) => {
        log.error(error);
      });
  }

  asyncFillInEmail(pages, widgetValues) {
    this.profileService.getPreferredOrLoginEmailAddress().then(emailAddress => {
      if (emailAddress) {
        this.fillInEmail(pages, widgetValues, emailAddress);
      }
    }).catch((error) => {
      log.error(error);
    });
  }

  asyncFillInProfileData(pages, widgetValues) {
    this.profileService.getSavedProfile()
      .then(profile => {
        this.fillInProfileData(pages, widgetValues, profile);
      })
      .catch(error => {
        console.log(error);
      });
  }

  isPreFillEnabled(): Promise <boolean> {
    return new Promise((resolve) => {
      let isPreFillEnabled;
      this.userService.getEnableSharing(2).then(preferences => {
        const enableSharingItem  = _.find(preferences, item => item && item.name === 'enable_sharing');
        if (!enableSharingItem) {
          isPreFillEnabled = true;
        } else {
          // There are a couple of oddities here hence the non-vanilla string-to-boolean conversion
          isPreFillEnabled = this.stringToBoolean(enableSharingItem.value);
        };
        resolve(isPreFillEnabled);
      });
    });
  }

  stringToBoolean(strValue) {
    return (strValue && typeof strValue === 'string') ?
      (strValue.toLowerCase() === 'true' || strValue === '1') : (strValue === true);
  }
}



// WEBPACK FOOTER //
// ./app/widgets/templateDrivenWidget/pre-fill.service.ts